<script>
import { toRaw, toValue } from 'vue'

export default {
  props: {
    boxContents: Object,
    boxNum: Number,
    products: Object,
    selectedBox: Number,
  },
  data() {
    return {
      localValue: '',
      copy: false,
      copyText: '',
      newBarcode: ''
    }
  },
  methods: {
    //edit later
    handleEnter() {
      //if it exists
      if (this.localValue) {
       this.newBarcode = this.localValue
        while (this.newBarcode.charAt(0) === '0') {
          this.newBarcode = this.newBarcode.substring(1)
        }
        
    
        var product = this.products.filter(
          (el) => el['Variant Barcode'] === this.newBarcode.toString(),
        )[0]
        if (product) {
          var size = ''
          if (product['Option1 Value'].length > 2) {
            size = product['Option2 Value']
          } else {
            size = product['Option1 Value']
          }

          var productName = String(product['Title'] + ' ' + size)

          this.boxContents.barcode.push(this.newBarcode)
          this.boxContents.name.push(productName)
        } else {
          console.log('Not a valid barcode. Please enter again')
        }
      }

      this.localValue = ''
    },
    deleteItem(i) {
      this.boxContents.barcode.splice(i, 1)
      this.boxContents.name.splice(i, 1)
    },
    copyBox() {
      console.log(this.boxContents.barcode)
      for(var i = 0; i < this.boxContents.barcode.length; i ++){
        console.log(i)
        this.copyText = this.copyText + this.boxContents.barcode[i].toString() + '\n'
      }

      // Copy the text inside the text field
      navigator.clipboard.writeText(this.copyText);
      this.copy = true

      setTimeout(() => {
        this.copy = false
      }, 3000)
    },
  },

  created(){
    
  }
}
</script>
//Test barcode
//30058633
<template>
  <div class="box">
    Box {{ boxNum + 1 }} <br />
    <br />
    <table id="table">
      <th>Barcode</th>
      <th>Item Name</th>
      <tr v-for="(barcode, barcodeIndex) in this.boxContents.barcode">
        <td class="arr">
          {{ barcode }}
        </td>
        <td class="arr">
          {{ this.boxContents.name[barcodeIndex] }}
          <button id="x-btn" @click="deleteItem(barcodeIndex)">
            <img src="@/assets/x.png" alt="x" />
          </button>
        </td>
      </tr>
    </table>
    <input v-model="localValue" @keyup.enter="handleEnter" placeholder="Enter Barcode" /> <br />
    <button @click="copyBox()">Copy Box</button>
    <p id="copied" v-if="this.copy">Copied</p>
  </div>
</template>

<style lang="scss" scoped>
.box {
  margin: 1em;
  padding: 1em;
  background-color: rgba(0, 0, 0, 0.336);
  min-height: 2em;
  min-width: 2em;
  border-radius: 20px;
  table,
  th,
  td {
    border: 1px solid rgb(80, 80, 80);
  }
  #table {
    margin: auto;
  }
  #x-btn {
    border: none;
    cursor: pointer;
    appearance: none;
    background-color: inherit;
    align-items: center;

    &:hover {
      opacity: 75%;
    }
  }
  img {
    width: 0.75em;
    height: 0.75em;
  }
  #copied {
    color: rgb(103, 255, 103);
    font-weight: bold;
  }
}
</style>
